export const formatToBRL = (value: string): string => {
  const numberValue = parseFloat(value)
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(numberValue)
}

export const applyMaskBrlCurrency = (value: string): string => {
  console.log(value)

  if (!value) return '0,00'

  // Verifica se o valor é negativo
  const isNegative = value.includes('-')
  const numericValue = parseFloat(value.replace(/[^\d-]/g, '') || '0') / 100

  // Formata o valor com suporte a negativos
  const formattedValue = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(isNegative ? -Math.abs(numericValue) : numericValue)

  return formattedValue.length > 15 ? formattedValue.slice(0, 15) : formattedValue
}

export const applyMaskBrlCurrencyFloat = (value: number | string | undefined): string => {
  if (!value) return '0,00' // Retorna um valor padrão caso o número não seja válido

  if (typeof value === 'string') {
    value = parseFloat(value)
  }

  if (isNaN(value)) return '0,00' // Retorna um valor padrão caso o número não seja válido

  // Formata o valor como moeda brasileira
  const formattedValue = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value)

  // Limita o tamanho máximo para 15 caracteres, se necessário
  return formattedValue.length > 15 ? formattedValue.slice(0, 15) : formattedValue
}

export const formatCurrencyToNumber = (currency: string): number => {
  if (!currency) return 0

  const sanitized = currency.replace(/[^\d,-]/g, '').replace('.', '')

  const formatted = sanitized.replace(',', '.')

  return parseFloat(formatted) || 0
}
